<template>

    <div class="block-hero" id="block-hero">
        <div class="header-info">
            <!-- <img src="/img/ewigo.svg" alt="logo ewigo"> -->
            <img src="/img/ewigo_baseline.svg" alt="logo ewigo">
            <div class="description">VENDEZ VOTRE VOITURE<br><b>DANS LA JOURNÉE</b></div>
            <div class="boutons">
                <a href="https://www.ewigo.com" class="bouton-gris">EWIGO FRANCE</a>
            </div>
        </div>
        <div class="bandeau-estimation" id="bandeau-estimation">
            <div class="estimation-gratuite">ESTIMATION GRATUITE</div>
            <div class="fff">
                <img src="/img/label-franchise.png" class="logo-label" alt="label meilleurs franchisés et partenaires">
                <img src="/img/fff.png" alt="logo fédération française franchise">
            </div>
        </div>
    </div>
    <div class="block-achat-estimation" id="block-achat-estimation">
        <div id="card-achat" class="card-achat">
            <div class="container-content">
                <!-- <table class="gradient-title-for-safari">
                    <tr class="title-tr">
                        <td>Reprise<br><b>CASH</b></td>
                        <td>Dépôt-Vente<br><b>VIRTUEL</b></td>
                    </tr>
                </table>
                <table>
                    <tr class="subtitle">
                        <td>
                            Vente<br><b>instantanée</b>
                        </td>
                        <td>
                            Vente en moyenne<br><b>en 20 jours</b>
                        </td>
                    </tr>
                    <tr class="description">
                        <td>
                            Estimation<br><b>en direct et gratuite</b><br><br>
                            Prix de vente calculé <b>selon le prix du marché et remise en état du véhicule</b><br><br>
                            Versement des fonds <b>48 heures seulement</b>
                        </td>
                        <td>
                            Estimation<br><b>en direct et gratuite</b><br><br>
                            Prix de vente calculé <b>selon le prix du marché</b><br><br>
                            Tâches administratives<br><b>prises en charge par Ewigo</b><br><br>
                            <b>Conservation du véhicule</b><br>pendant la durée du mandat
                        </td>
                    </tr>
                </table> -->

                <div class="title">Achat <b>CASH</b><br>de votre voiture d’occasion.</div>
                <div class="description">
                    <span>
                        Reprise de votre voiture d'occasion en agence EWIGO ou <b>directement chez vous</b>.
                        <br><br>
                        Simple, rapide, gratuit<br>et sans obligation !
                    </span>
                    <div class="block-logos">
                        <div class="logo">
                            <img src="/img/cadenas.svg" alt="cadenas">
                            <span>Transaction<br>sécurisée</span>
                        </div>
                        <div class="logo">
                            <img src="/img/lieu.svg" alt="lieu">
                            <span>Interlocuteur<br>local</span>
                        </div>
                        <div class="logo">
                            <img src="/img/chrono.svg" alt="chronomètre">
                            <span>Achat<br>rapide</span>
                        </div>
                    </div>
                </div>

                <div class="bg-reprise">
                    <div class="bouton-gris-transp">
                        <a href="#card-estimation"><span>estimer mon véhicule</span></a>
                        <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 0C0.895 0 0 0.895 0 2V18C0 19.105 0.895 20 2 20H12.4277C12.1437 19.337 12 18.641 12 18H2V6H14V8H16V2C16 0.895 15.105 0 14 0H2ZM2 2H14V4H2V2ZM4 8V10H6V8H4ZM7 8V10H9V8H7ZM10 8V10H12V8H10ZM16 10V11.1992C15 11.4992 14 12.4 14 14C14 15.9 15.5996 16.5004 16.5996 16.9004C17.7996 17.4004 18 17.5 18 18C18 18.5 17.8 19 17 19C16.2 19 16 18.5 16 18H14C14 19 14.6 20.4008 16 20.8008V22H18V20.8008C19.4 20.4008 20 19 20 18C20 16.1 18.4004 15.4996 17.4004 15.0996C16.2004 14.5996 16 14.5 16 14C16 13.2 16.5 13 17 13C17.8 13 18 13.5 18 14H19H20C20 13 19.4 11.5992 18 11.1992V10H16ZM4 11V13H6V11H4ZM7 11V13H9V11H7ZM10 11V13H12V11H10ZM4 14V16H6V14H4ZM7 14V16H12V14H7Z"/>
                        </svg>
                    </div>
                </div>
            </div>


        </div>
        <div class="card-estimation" id="card-estimation">
            <div class="title">Estimez le prix de rachat du véhicule.<br><b>Gratuit & sans engagement.</b></div>
            <div class="steps-estimation" v-if="currentStep == 1">
                <div class="block-progression">
                    <div class="arrow-number">
                        <div class="previous-arrow" id="previous-arrow" v-if="currentStep > 1"></div>
                        <span id="steps-number">1/3</span>
                    </div>
                    <div class="steps-bg"><div class="steps-orange"></div></div>
                </div>

                <div class="form">
                    <input type="number" v-model="form.mileage" name="kilometers" id="km" placeholder="Kilométrage" required>
                    <div class="label-immat">Immatriculation</div>
                    <input type="text" v-model="form.registration" v-mask="getRegistrationMask" masked="true" name="registration" id="immat" class="immat" placeholder="AA - 123 - AA" pattern="^[A-Z]{2} ?- ?\d{3} ?- ?[A-Z]{2}$" required>
                    <p id="errorInput" class="errorImmat">Votre immatriculation n'est pas reconnue</p>
                </div>


                <div id="nextButton" class="bouton-orange" @click="goToStep2()">
                    <span id="buttonContent">Suivant</span>
                    <svg id="svgImage" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path id="buttonSvgPath" d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z"/>
                    </svg>
                </div>
                <a href="https://www.google.fr/" target="_blank" id="avis-google">
                    <img src="/img/gmb.png" class="avis-google" alt="avis google">
                </a>
            </div>


            <div class="steps-estimation" v-if="currentStep == 2">
                <div class="block-progression">
                    <div class="arrow-number">
                        <div class="previous-arrow" @click="currentStep = 1"></div>
                        <span id="steps-number">2/3</span>
                    </div>
                    <div class="steps-bg"><div class="steps-orange" style="width: 66.6667%;"></div></div>
                </div>

                <div class="form" id="autobizzResult">
                    <div class="simu-plaque" id="simu-plaque">{{form.registration}}</div>
                    <div class="hr-grey"></div>
                    <div class="modele">
                        <div id="modele"></div>
                        {{autobizData.makeName}} {{autobizData.modelName}}
                        <div class="caracteristiques">
                            <div>
                                <img src="/img/carburant.svg" alt="logo carburant">
                                <div id="carburant"></div>
                                {{autobizData.fuelName}}
                            </div>
                            <div>
                                <img src="/img/couleur.svg" alt="logo couleur">
                                <div id="color"></div>
                                {{autobizData.color}}
                            </div>
                        </div>
                        <p id="errorAutobizz" class="errorImmat">Votre immatriculation n'est pas reconnue</p>

                    </div>
                    <div class="hr-grey"></div>
                    <div class="label-immat">Finition</div>
                    <div class="select-wrapper">
                        <select name="finition" id="finition-select" class="not-selected" v-model="form.finition">
                            <option v-for="version in autobizData.versions" :key="version.id"  :value="version.name">{{version.name}}</option>
                        </select>
                    </div>

                    <!-- <span class="dropdown-arrow"></span> -->
                    <div class="label-immat">
                        <span>Etat</span>
                        <div class="aide-etat">
                            <img src="/img/point-interrogation.svg" class="aide-etat" alt="point d'interrogation">
                        </div>
                    </div>
                    <div class="container-etats" id="etats">
                        <input type="radio" v-model="form.state" id="proche-neuf" name="etat" value="proche-neuf" checked>
                        <label class="label-radio" for="proche-neuf">Proche du neuf</label>
                        <input type="radio" v-model="form.state" id="bon" name="etat" value="bon">
                        <label class="label-radio" for="bon">Bon</label>
                        <input type="radio" v-model="form.state" id="correct" name="etat" value="correct">
                        <label class="label-radio" for="correct">Correct</label>
                        <input type="radio" v-model="form.state" id="mauvais" name="etat" value="mauvais">
                        <label class="label-radio" for="mauvais">Mauvais</label>
                        <input type="radio" v-model="form.state" id="nul" name="etat" value="nul">
                        <label class="label-radio" for="nul">Très mauvais, accidenté</label>
                    </div>
                    <textarea id="commentaire" v-model="form.note" class="commentaire" placeholder="Commentaires" rows="4"></textarea>
                </div>

                <div id="nextButton" class="bouton-orange" @click="currentStep = 3">
                    <span id="buttonContent">Suivant</span>
                    <svg id="svgImage" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path id="buttonSvgPath" d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z"/>
                    </svg>
                </div>

            </div>



            <div class="steps-estimation" v-if="currentStep == 3">
                <div class="block-progression">
                    <div class="arrow-number">
                        <div class="previous-arrow" id="previous-arrow" @click="currentStep = 2"></div>
                        <span id="steps-number">3/3</span>
                    </div>
                    <div class="steps-bg"><div class="steps-orange" style="width:100%"></div></div>
                </div>

                <div class="form">
                    <input v-model="form.last_name" type="text" id="lastname" placeholder="Nom" required>
                    <input v-model="form.first_name" type="text" id="firstname" placeholder="Prénom" required>
                    <input v-model="form.email" type="email" id="email" placeholder="Email" required>
                    <input v-model="form.city" type="text" id="town" placeholder="Ville" required>
                    <input v-model="form.postal_code" type="text" id="postalcode" placeholder="Code postal" required maxlength="5" pattern="[0-9]{5}">
                    <input v-model="form.phone" type="tel" id="phone" placeholder="Téléphone" maxlength="14" required>
                    <div class="accept">
                        <input type="checkbox" id="accept" name="accept">
                        <label for="accept" id="accept-label">
                            En soumettant ce formulaire, j'accepte que les informations saisies soient utilisées pour me recontacter.
                        </label>
                    </div>

                    <div id="nextButton" class="bouton-orange" @click="submitForm()">
                        <span>Estimer</span>
                        <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 0C0.895 0 0 0.895 0 2V18C0 19.105 0.895 20 2 20H12.4277C12.1437 19.337 12 18.641 12 18H2V6H14V8H16V2C16 0.895 15.105 0 14 0H2ZM2 2H14V4H2V2ZM4 8V10H6V8H4ZM7 8V10H9V8H7ZM10 8V10H12V8H10ZM16 10V11.1992C15 11.4992 14 12.4 14 14C14 15.9 15.5996 16.5004 16.5996 16.9004C17.7996 17.4004 18 17.5 18 18C18 18.5 17.8 19 17 19C16.2 19 16 18.5 16 18H14C14 19 14.6 20.4008 16 20.8008V22H18V20.8008C19.4 20.4008 20 19 20 18C20 16.1 18.4004 15.4996 17.4004 15.0996C16.2004 14.5996 16 14.5 16 14C16 13.2 16.5 13 17 13C17.8 13 18 13.5 18 14H19H20C20 13 19.4 11.5992 18 11.1992V10H16ZM4 11V13H6V11H4ZM7 11V13H9V11H7ZM10 11V13H12V11H10ZM4 14V16H6V14H4ZM7 14V16H12V14H7Z"/>
                        </svg>
                    </div>
                </div>

            </div>


            <div id="merci" class="merci" v-if="currentStep == 4">
                <span class="title-merci">Merci !</span>
                <p>
                    Une fois votre véhicule estimé, nous prendrons contact avec vous par e-mail ou par téléphone.
                </p>
                <a href="/">
                    <div class="bouton-orange">
                        <span>Consulter notre site</span>
                    </div>
                </a>
            </div>
        </div>
    </div>

    <div class="vendez">
        <div class="title">
            <b>Vendez rapidement</b><br>votre véhicule d'occasion
        </div>
        <div class="description">
            Ewigo reprend votre véhicule cash, rapidement, de manière sécurisée.<br>
            Vous rencontrez votre interlocuteur local EWIGO.<br><br>
            Votre transaction se fait en toute simplicité :
        </div>
        <div class="container">
            <div class="card-vendez">
                <div class="cercle-orange">1</div>
                <div class="title">Estimation</div>
                <div class="description">
                    Une fois votre demande d'estimation validée, nous vous envoyons votre résultat par email.<br><br>
                    En fonction des modèles, il est possible que nous ayons besoin de plus d'informations.<br><br>
                    L’objectif d'Ewigo est de vous proposer une reprise personnalisée, qui correspond réellement au modèle et à l'état de votre véhicule.
                </div>
            </div>
            <div class="card-vendez">
                <span class="cercle-orange">2</span>
                <div class="title">Visite</div>
                <div class="description">
                    Sur l'un de nos parcs  ou directement chez vous, l'un de nos techniciens réalise l'estimation précise de votre voiture.<br><br>
                    Vous lui fournissez tous les éléments en votre possession pouvant donner de la valeur à votre automobile :<br><br>
                    <ul>
                        <li>Carnet d'entretien</li>
                        <li>Factures</li>
                        <li>Etc</li>
                    </ul>
                </div>
            </div>
            <div class="card-vendez">
                <span class="cercle-orange">3</span>
                <div class="title">Proposition</div>
                <div class="description">
                    Ewigo vous propose son prix d'achat. Vous pouvez librement accepter ou refuser.<br><br>
                    En cas d'acceptation, la vente de votre voiture peut se faire immédiatement.<br><br>
                    Vous recevrez alors les fonds sous 48h, en fonction des délais de votre établissement bancaire.
                </div>
            </div>

        </div>
    </div>
    <div class="block-confiance">
        <div class="flex-title">
            <div class="bouton-orange">
                <a href="#card-estimation" style="appearance: none;"><span>estimer mon véhicule</span></a>
                <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 0C0.895 0 0 0.895 0 2V18C0 19.105 0.895 20 2 20H12.4277C12.1437 19.337 12 18.641 12 18H2V6H14V8H16V2C16 0.895 15.105 0 14 0H2ZM2 2H14V4H2V2ZM4 8V10H6V8H4ZM7 8V10H9V8H7ZM10 8V10H12V8H10ZM16 10V11.1992C15 11.4992 14 12.4 14 14C14 15.9 15.5996 16.5004 16.5996 16.9004C17.7996 17.4004 18 17.5 18 18C18 18.5 17.8 19 17 19C16.2 19 16 18.5 16 18H14C14 19 14.6 20.4008 16 20.8008V22H18V20.8008C19.4 20.4008 20 19 20 18C20 16.1 18.4004 15.4996 17.4004 15.0996C16.2004 14.5996 16 14.5 16 14C16 13.2 16.5 13 17 13C17.8 13 18 13.5 18 14H19H20C20 13 19.4 11.5992 18 11.1992V10H16ZM4 11V13H6V11H4ZM7 11V13H9V11H7ZM10 11V13H12V11H10ZM4 14V16H6V14H4ZM7 14V16H12V14H7Z" fill="white"/>
                </svg>
            </div>
            <span class="title">Ils nous ont fait confiance</span>
        </div>
        <div class="flex-avis-photo">
            <div class="reviews-auto">

                <carousel :autoplay="2000" :wrap-around="true" :itemsToShow="1.15">
                    <slide v-for="(review, index) in reviews" :key="`review-${review.id}-${index}`">
                        <div class="card-avis">
                            <div class="block-profil">
                                <img :src="review.profile_photo_url" alt="image de profil">
                                <div class="block-avis">
                                    <span>{{ review.author_name }}</span>
                                    <div class="box-rating" id="box-rating">
                                        <div class="rating"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="avis">
                                {{review.text.substring(0,200)+"..."}}
                            </div>
                            <div class="details">
                                <div>
                                    <svg width="8.74" height="12.5" viewBox="0 0 24 34" fill="#828282" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <path d="M11.6536 0C5.22698 0 0 5.23023 0 11.6569C0 19.1286 9.9445 31.2657 10.3678 31.7773L11.6536 33.3366L12.9395 31.7773C13.3628 31.264 23.3073 19.1286 23.3073 11.6569C23.3073 5.22857 18.0803 0 11.6536 0ZM11.6536 3.33333C16.242 3.33333 19.974 7.06857 19.974 11.6569C19.974 16.1652 14.7836 23.919 11.6536 28.0273C8.52365 23.9223 3.33333 16.1719 3.33333 11.6569C3.33333 7.06857 7.06531 3.33333 11.6536 3.33333ZM11.6536 7.48372C9.35198 7.48372 7.48698 9.34872 7.48698 11.6504C7.48698 13.9521 9.35198 15.8171 11.6536 15.8171C13.9553 15.8171 15.8203 13.9521 15.8203 11.6504C15.8203 9.34872 13.9553 7.48372 11.6536 7.48372Z" fill="url(#pattern0)"/>
                                        <path d="M11.6536 0C5.22698 0 0 5.23023 0 11.6569C0 19.1286 9.9445 31.2657 10.3678 31.7773L11.6536 33.3366L12.9395 31.7773C13.3628 31.264 23.3073 19.1286 23.3073 11.6569C23.3073 5.22857 18.0803 0 11.6536 0ZM11.6536 3.33333C16.242 3.33333 19.974 7.06857 19.974 11.6569C19.974 16.1652 14.7836 23.919 11.6536 28.0273C8.52365 23.9223 3.33333 16.1719 3.33333 11.6569C3.33333 7.06857 7.06531 3.33333 11.6536 3.33333ZM11.6536 7.48372C9.35198 7.48372 7.48698 9.34872 7.48698 11.6504C7.48698 13.9521 9.35198 15.8171 11.6536 15.8171C13.9553 15.8171 15.8203 13.9521 15.8203 11.6504C15.8203 9.34872 13.9553 7.48372 11.6536 7.48372Z" fill="#828282"/>
                                    </svg>
                                    Ewigo France
                                </div>
                                <div>
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.99449 0.166992C2.77449 0.166992 0.166992 2.78033 0.166992 6.00033C0.166992 9.22033 2.77449 11.8337 5.99449 11.8337C9.22033 11.8337 11.8337 9.22033 11.8337 6.00033C11.8337 2.78033 9.22033 0.166992 5.99449 0.166992ZM6.00033 10.667C3.42199 10.667 1.33366 8.57866 1.33366 6.00033C1.33366 3.42199 3.42199 1.33366 6.00033 1.33366C8.57866 1.33366 10.667 3.42199 10.667 6.00033C10.667 8.57866 8.57866 10.667 6.00033 10.667Z" fill="#828282"/>
                                        <path d="M6.29199 3.08301H5.41699V6.58301L8.47949 8.42051L8.91699 7.70301L6.29199 6.14551V3.08301Z" fill="#828282"/>
                                    </svg>
                                    {{review.relative_time_description}}
                                </div>
                            </div>
                        </div>
                    </slide>


                    <template #addons>
                        <navigation />
                        <pagination />
                    </template>
                </carousel>
            </div>
            <div class="photo-auto">
                <!-- <img src="/img/photo-audi.png" alt="photo Audi"> -->
            </div>
        </div>
        <div class="hr-grey"></div>
    </div>
    <footer>
        <img src="/img/logo-ewigo.svg" alt="logo ewigo">
        <p class="mentions">
            Conformément à la loi "Informatique et libertés" du 6 Janvier 1978 modifiée en 2004, vous bénéficiez d'un droit d'accès et de rectification aux informations qui vous concernent, que vous pouvez exercer en vous adressant à 3 rue Marius Hué, 78530 Verrières-le-Buisson. Si vous ne souhaitez pas faire l'objet d'une prospection commerciale par voie téléphonique, vous pouvez vous inscrire sur la liste d'opposition au démarchage téléphonique à l'adresse suivante : http://www.bloctel.gouv.fr/. En remplissant le formulaire ci-dessus, vous acceptez qu'Ewigo puisse vous contacter par téléphone au numéro que vous avez communiqué.
        </p>
        <div class="copyright">EWIGO © COPYRIGHT 2022</div>
    </footer>




</template>

<script>
import _, {throttle} from 'lodash';
import {mask} from 'vue-the-mask'
import { trackGenerateLead } from '@/ewigo-analytics';
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'

export default {
    directives: {mask},
    props: {
        agency: Object,
        registration: String,
        mileage: String,
        title: String,
        description:String,
        reference: String,
    },
    components: {
        Carousel,
        Slide,
        Pagination,
        Navigation,
    },
    data() {
        return {
            currentStep: 1,
            autobizData: false,
            form: this.$inertia.form({
                registration: this.registration,
                mileage: this.mileage,
                note: null,
                state: null,
                first_name:null,
                last_name:null,
                email:null,
                city: null,
                postal_code: null,
                phone: null,
                finition: null,
                reference: this.reference,
                make: null,
                model: null,
                fuel: null,
                color: null,
                year: null,
            }),
            reviews: [],
            showFakeReviews: false,
        }
    },
    watch: {
        autobizData: {
            deep: true,
            handler: _.debounce(function () {
                this.form.make = this.autobizData.makeName
                this.form.model = this.autobizData.modelName
                this.form.fuel = this.autobizData.fuelName
                this.form.color = this.autobizData.color
                this.form.year = this.autobizData.dateRelease

            }, 100)
        },
    },
    computed: {
        getRegistrationMask()
        {
            if (!this.form.registration) return 'X';
            if (!isNaN(this.form.registration.charAt(0)))
            {
                return '#### AAA ##';
            }else{
                return 'AA-###-AA';
            }
        },
    },
    methods: {
        getReviews() {
            axios.get(`${this.$page.props.ewigoExtranetUrl}/api/get/reviews`)
                .then((response) => {
                    this.showFakeReviews = false;
                    this.reviews = response.data.data;
                })
                .catch((error) => {
                    if (error) {
                        this.showFakeReviews = true;
                        this.reviews = [];
                        // refresh
                    }
                })
        },
        goToStep2() {
            if (!this.form.registration || this.form.registration.length < 9) {
                document.getElementById("errorInput").style.display = "block";
            }
            if(this.form.registration.length == 9 || this.form.registration.length == 11){
                this.currentStep = 2
                this.getAutobiz()
            }

        },
        getAutobiz() {
            axios.post(route('minisite.autobiz.infos'), {registration: this.form.registration})
                .then((response) => {
                    console.log(response)
                    this.autobizData = response.data
                    if (!response.data.status) {
                        document.getElementById("errorAutobizz").style.display = "block";
                        document.getElementsByClassName("caracteristiques")[0].style.display = "none";
                    }
                })
        },
        submitForm() {
            axios.post(route('reseau.send.email'), this.form)
                .then((response) => {
                    this.currentStep = 4
                    trackGenerateLead()
                })
        },
    },
    created() {
        this.getReviews();
    },
    mounted: function() {
        document.getElementsByTagName("body")[0].style.overflowY = "scroll";
    }
}
</script>

<style lang="scss" scoped>
.bouton-gris-transp {
    a {
        color: #F07D00;
        span {
            white-space: nowrap;
        }
    }
}
.errorImmat {
    display: none;
    color: #ff5151;
    font-size: 1rem;
    margin: 10px 0 0;
}
</style>
